/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./BarChartRace.vue?vue&type=template&id=391630ac"
import script from "./BarChartRace.vue?vue&type=script&lang=js"
export * from "./BarChartRace.vue?vue&type=script&lang=js"
import style0 from "./BarChartRace.vue?vue&type=style&index=0&id=391630ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports